<script>
export default {
  name: "MemberListAll",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var cfg = this.config || {};
    var flash = cfg.flash && typeof cfg.flash === "object" ? cfg.flash : null;
    var defaultWriterType = String(cfg.defaultWriterType || "").trim();
    return {
      loading: true,
      error: "",
      flash: flash,
      searchBy: "first_name",
      searchKeyword: "",
      writerType: defaultWriterType,
      rightsholderType: "",
      status: "active",
      createdSource: "",
      sort: "name",
      page: 1,
      perPage: 10,
      totalPages: 1,
      from: 0,
      to: 0,
      total: 0,
      rows: [],
      stats: { total: 0, general: 0, associate: 0, provisional: 0 },
      debounceTimer: null,
      deletingCode: "",
    };
  },
  computed: {
    canDelete: function () {
      return !!(this.config && this.config.canDelete);
    },
    canAdd: function () {
      if (!this.config || typeof this.config.canAdd === "undefined") {
        return true;
      }
      return !!this.config.canAdd;
    },
    memberAddHref: function () {
      return String((this.config && this.config.memberAddHref) || "main-manage-member.php?page=member_add");
    },
    pageTitle: function () {
      return String((this.config && this.config.pageTitle) || "รายการสมาชิกทั้งหมด");
    },
    breadcrumbSection: function () {
      return String((this.config && this.config.breadcrumbSection) || "");
    },
    breadcrumbActive: function () {
      return String((this.config && this.config.breadcrumbActive) || this.pageTitle);
    },
    defaultWriterType: function () {
      return String((this.config && this.config.defaultWriterType) || "");
    },
    searchPlaceholder: function () {
      var map = {
        member_code: "เช่น MCT26040001",
        internal_no: "เช่น 503660",
        ipi_name_no: "เช่น 00216126011",
        ipi_base_no: "เช่น I-000511005-2",
        pen_name: "นามปากกา ไทยหรืออังกฤษ",
        email: "เช่น name@example.com",
        mobile: "เช่น 081 234 5678",
      };
      return map[this.searchBy] || "ชื่อบุคคล ชื่อบริษัท หรือนามปากกา";
    },
    searchTitle: function () {
      var map = {
        member_code: "รูปแบบ MCTYYMM + ลำดับ 4 หลัก — ค้นหาบางส่วนได้",
        internal_no: "ค้นหาบางส่วนได้ — ตัวเลขเท่านั้น",
        ipi_name_no: "ค้นหาบางส่วนได้ — ตัวเลขเท่านั้น",
        ipi_base_no: "รูปแบบ I-XXXXXXXXX-Y — ค้นหาบางส่วนได้",
        pen_name: "ค้นหาบางส่วนได้",
        email: "ค้นหาบางส่วนได้",
        mobile: "ค้นหาบางส่วนได้ — ไม่ต้องใส่ครบทุกหลัก",
      };
      return map[this.searchBy] || "ค้นชื่อแสดงและนามปากกา";
    },
    metaText: function () {
      if (this.loading) {
        return "กำลังค้นหา...";
      }
      if (this.error) {
        return "เกิดข้อผิดพลาด";
      }
      return "แสดงผลหน้า " + this.page + " / " + this.totalPages + " (" + this.perPage + " แถวต่อหน้า)";
    },
    pageInfoText: function () {
      if (this.loading || this.error) {
        return "-";
      }
      return "แสดง " + this.from + "-" + this.to + " จากทั้งหมด " + this.total + " รายการ";
    },
    pageNumbers: function () {
      var start = Math.max(1, this.page - 2);
      var end = Math.min(this.totalPages, start + 4);
      start = Math.max(1, end - 4);
      var nums = [];
      var i;
      for (i = start; i <= end; i++) {
        nums.push(i);
      }
      return nums;
    },
    sortIconName: function () {
      return this.sort === "name" ? "ri-arrow-up-line" : "ri-arrow-up-down-line";
    },
    sortIconCode: function () {
      if (this.sort === "member_code_desc") {
        return "ri-arrow-down-line";
      }
      if (this.sort === "member_code_asc") {
        return "ri-arrow-up-line";
      }
      return "ri-arrow-up-down-line";
    },
    displayRows: function () {
      var self = this;
      return this.rows.map(function (row) {
        var code = String(row.member_code || "").trim();
        return {
          row: row,
          code: code,
          name: self.nameParts(row),
          avatarSrc: self.avatarSrc(row),
          avatarLetter: self.avatarLetter(row),
          email: String(row.email || "").trim(),
          mobile: String(row.mobile || "").trim(),
          ipiName: String(row.ipi_name_no || "").trim(),
          ipiBase: String(row.ipi_base_no || "").trim(),
        };
      });
    },
  },
  mounted: function () {
    this.loadMembers(1);
  },
  beforeUnmount: function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    safeCell: function (value) {
      var text = String(value || "").trim();
      return text === "" ? "-" : text;
    },
    canonicalWriterType: function (value) {
      var s = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
      if (s === "general" || s === "general member") {
        return "General Member";
      }
      if (s === "associate" || s === "associate member") {
        return "Associate Member";
      }
      if (s === "provisional" || s === "provisional member") {
        return "Provisional Member";
      }
      return String(value || "").trim();
    },
    memberStatusLabel: function (value) {
      var s = String(value || "").trim().toLowerCase();
      if (s === "active") {
        return "ใช้งาน";
      }
      if (s === "inactive") {
        return "ไม่ใช้งาน";
      }
      if (s === "suspended") {
        return "ระงับ";
      }
      if (s === "resigned") {
        return "ลาออก";
      }
      if (s === "deceased") {
        return "เสียชีวิต";
      }
      return String(value || "").trim() === "" ? "-" : String(value || "").trim();
    },
    memberStatusBadgeClass: function (value) {
      var s = String(value || "").trim().toLowerCase();
      if (s === "active") {
        return "bg-success-subtle text-success";
      }
      if (s === "inactive") {
        return "bg-secondary-subtle text-muted";
      }
      if (s === "suspended") {
        return "bg-warning-subtle text-warning";
      }
      if (s === "resigned") {
        return "bg-dark-subtle text-body";
      }
      if (s === "deceased") {
        return "bg-danger-subtle text-danger";
      }
      return "bg-light text-muted";
    },
    createdSourceLabel: function (value) {
      var s = String(value || "").trim().toLowerCase();
      if (s === "online_application") {
        return "ใบสมัครออนไลน์";
      }
      if (s === "manual_add") {
        return "เพิ่มสมาชิกออฟไลน์";
      }
      return "";
    },
    createdSourceIconClass: function (value) {
      var s = String(value || "").trim().toLowerCase();
      if (s === "online_application") {
        return "ri-global-line text-info";
      }
      if (s === "manual_add") {
        return "ri-computer-line text-secondary";
      }
      return "";
    },
    normalizeListName: function (s) {
      var t = String(s || "")
        .trim()
        .replace(/\s+/g, " ");
      return typeof t.normalize === "function" ? t.normalize("NFC") : t;
    },
    dedupeAdjacentIdenticalPhrase: function (t) {
      var s = this.normalizeListName(t);
      if (s.length < 8) {
        return s;
      }
      var i;
      var half = Math.floor(s.length / 2);
      for (i = Math.max(1, half - 60); i <= Math.min(s.length - 2, half + 60); i++) {
        if (s.charAt(i) !== " ") {
          continue;
        }
        var left = s.slice(0, i).trim();
        var right = s.slice(i + 1).trim();
        if (left.length > 0 && left === right) {
          return left;
        }
      }
      return s;
    },
    isOrgLocalAlreadyInMainLine: function (localPart, mainNorm) {
      if (!localPart || !mainNorm) {
        return false;
      }
      if (mainNorm === localPart) {
        return true;
      }
      if (mainNorm.indexOf(localPart) !== 0) {
        return false;
      }
      if (mainNorm.length === localPart.length) {
        return true;
      }
      var sep = mainNorm.charAt(localPart.length);
      return sep === " " || sep === "·" || sep === "-" || sep === "/";
    },
    nameParts: function (row) {
      var rawFirst = row.first_name != null ? String(row.first_name).trim() : "";
      var deduped = this.dedupeAdjacentIdenticalPhrase(rawFirst);
      var mainRaw = deduped === "" ? "-" : deduped;
      var mainNorm = this.normalizeListName(mainRaw === "-" ? "" : mainRaw);
      var pen = this.normalizeListName(row.pen_name || "");
      var loc = row.org_name_local ? this.normalizeListName(row.org_name_local) : "";
      var eng = row.org_name_eng ? this.normalizeListName(row.org_name_eng) : "";
      var badges = [];
      var writerType = this.canonicalWriterType(row.writer_type);
      if (writerType) {
        badges.push({ cls: "badge bg-info-subtle text-info", text: writerType });
      }
      var rhs = String(row.rightsholder_type || "").trim();
      if (rhs) {
        badges.push({ cls: "badge bg-secondary-subtle text-muted", text: rhs });
      }
      if (Number(row.creative_role_melody) === 1) {
        badges.push({ cls: "badge bg-primary-subtle text-primary", text: "ทำนอง" });
      }
      if (Number(row.creative_role_lyrics) === 1) {
        badges.push({ cls: "badge bg-primary-subtle text-primary", text: "เนื้อร้อง" });
      }
      if (Number(row.creative_role_arrangement) === 1) {
        badges.push({ cls: "badge bg-primary-subtle text-primary", text: "เรียบเรียง" });
      }
      return {
        main: mainRaw,
        pen: pen && pen !== mainNorm && mainNorm.indexOf(pen) === -1 ? pen : "",
        loc: loc && !this.isOrgLocalAlreadyInMainLine(loc, mainNorm) ? loc : "",
        eng: eng && eng !== mainNorm && eng !== loc ? eng : "",
        badges: badges,
      };
    },
    profileInitial: function (name) {
      var text = String(name || "").trim();
      if (!text) {
        return "M";
      }
      return text.charAt(0).toUpperCase();
    },
    publicHref: function (path) {
      var p = String(path || "").trim();
      if (!p) {
        return "";
      }
      if (/^https?:\/\//i.test(p)) {
        return p;
      }
      var b = String((this.config && this.config.basePath) || "").replace(/\/$/, "");
      var rel = p.replace(/^\/+/, "");
      return (b ? b + "/" : "") + rel;
    },
    avatarSrc: function (row) {
      var imagePath = String(row.profile_image_path || "").trim();
      return imagePath ? this.publicHref(imagePath) : "";
    },
    avatarLetter: function (row) {
      return this.profileInitial(this.dedupeAdjacentIdenticalPhrase(String(row.first_name || "").trim()));
    },
    displayName: function (row) {
      return this.dedupeAdjacentIdenticalPhrase(String(row.first_name || "").trim());
    },
    profileHref: function (code) {
      var base = String((this.config && this.config.profileBase) || "main-manage-member.php?page=view_profile&member_code=");
      return base + encodeURIComponent(String(code || "").trim());
    },
    currentFilters: function () {
      var keyword = String(this.searchKeyword || "").trim();
      return {
        internal_no: this.searchBy === "internal_no" ? keyword : "",
        ipi_name_no: this.searchBy === "ipi_name_no" ? keyword : "",
        ipi_base_no: this.searchBy === "ipi_base_no" ? keyword : "",
        member_code: this.searchBy === "member_code" ? keyword : "",
        first_name: this.searchBy === "first_name" ? keyword : "",
        pen_name: this.searchBy === "pen_name" ? keyword : "",
        email: this.searchBy === "email" ? keyword : "",
        mobile: this.searchBy === "mobile" ? keyword : "",
        writer_type: String(this.writerType || "").trim(),
        rightsholder_type: String(this.rightsholderType || "").trim(),
        status: String(this.status || "").trim(),
        created_source: String(this.createdSource || "").trim(),
      };
    },
    buildListParams: function (includePaging) {
      var params = new URLSearchParams();
      var filters = this.currentFilters();
      var key;
      if (includePaging) {
        params.set("page", String(this.page));
        params.set("per_page", String(this.perPage));
      }
      for (key in filters) {
        if (Object.prototype.hasOwnProperty.call(filters, key)) {
          params.set(key, filters[key]);
        }
      }
      params.set("exclude_rightsholder_type", "ทายาท");
      params.set("sort", String(this.sort || "name").trim());
      return params;
    },
    loadMembers: function (page) {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      this.page = Math.max(1, Number(page || 1));
      this.perPage = this.perPage === 25 || this.perPage === 50 ? this.perPage : 10;
      this.loading = true;
      this.error = "";
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของรายการสมาชิก";
        return;
      }
      fetch(apiUrl + "?" + this.buildListParams(true).toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data = {};
            try {
              data = text ? JSON.parse(text) : {};
            } catch (e) {
              throw new Error("API ไม่ได้ส่ง JSON ที่ถูกต้อง: " + String(text || "").slice(0, 140));
            }
            if (!res.ok) {
              throw new Error(data && data.message ? data.message : "ไม่สามารถโหลดข้อมูลสมาชิกได้");
            }
            return data;
          });
        })
        .then(function (data) {
          if (!data || data.success !== true) {
            throw new Error(data && data.message ? data.message : "ไม่สามารถโหลดข้อมูลสมาชิกได้");
          }
          self.rows = Array.isArray(data.rows) ? data.rows : [];
          self.page = Number(data.page || 1);
          self.totalPages = Math.max(1, Number(data.total_pages || 1));
          self.from = Number(data.from || 0);
          self.to = Number(data.to || 0);
          self.total = Number(data.total || 0);
          var pp = Number(data.per_page);
          if (!isNaN(pp) && (pp === 10 || pp === 25 || pp === 50)) {
            self.perPage = pp;
          }
          self.stats = Object.assign(
            { total: 0, general: 0, associate: 0, provisional: 0 },
            data.stats || {}
          );
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.rows = [];
          self.error = err && err.message ? err.message : "เกิดข้อผิดพลาดในการค้นหาข้อมูล";
        });
    },
    debounceLoad: function () {
      var self = this;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        self.loadMembers(1);
      }, 300);
    },
    onFilterChange: function () {
      this.loadMembers(1);
    },
    onPerPageChange: function () {
      var v = Number(this.perPage);
      this.perPage = v === 25 || v === 50 ? v : 10;
      this.loadMembers(1);
    },
    activateWriterFilter: function (next) {
      this.writerType = String(this.writerType || "").trim() === next ? "" : next;
      this.loadMembers(1);
    },
    onStatKey: function (event, next) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.activateWriterFilter(next);
      }
    },
    cycleSort: function (key) {
      var current = this.sort;
      var next = "name";
      if (key === "member_code") {
        next = current === "member_code_asc" ? "member_code_desc" : "member_code_asc";
      } else if (key === "created") {
        next = current === "created_desc" ? "created_asc" : "created_desc";
      }
      this.sort = next;
      this.loadMembers(1);
    },
    clearFilters: function () {
      this.searchBy = "first_name";
      this.searchKeyword = "";
      this.writerType = this.defaultWriterType;
      this.rightsholderType = "";
      this.status = "active";
      this.createdSource = "";
      this.sort = "name";
      this.perPage = 10;
      this.loadMembers(1);
    },
    exportCsv: function () {
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      if (apiUrl === "") {
        return;
      }
      var params = this.buildListParams(false);
      params.set("export", "csv");
      window.location.href = apiUrl + "?" + params.toString();
    },
    openProfile: function (code) {
      var c = String(code || "").trim();
      if (c) {
        window.location.href = this.profileHref(c);
      }
    },
    deleteMember: function (row) {
      var self = this;
      var delCode = String(row.member_code || "").trim();
      var delName = this.displayName(row);
      var deleteApi = String((this.config && this.config.deleteApiUrl) || "").trim();
      var confirmMsg;
      if (!this.canDelete || !delCode || !deleteApi) {
        return;
      }
      confirmMsg =
        "ยืนยันการลบข้อมูลสมาชิกนี้ถาวรหรือไม่?\n\n" +
        "รหัสสมาชิก: " +
        delCode +
        (delName ? "\nชื่อ: " + delName : "") +
        "\n\nระบบจะลบข้อมูลในฐานข้อมูลที่เกี่ยวข้อง และลบไฟล์เอกสาร (ถ้ามี)";
      if (!window.confirm(confirmMsg)) {
        return;
      }
      this.deletingCode = delCode;
      var payload = new URLSearchParams();
      payload.set("member_code", delCode);
      fetch(deleteApi, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        credentials: "same-origin",
        body: payload.toString(),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (!json || json.success !== true) {
            throw new Error(json && json.message ? json.message : "ไม่สามารถลบข้อมูลได้");
          }
          window.alert("ลบข้อมูลสมาชิกเรียบร้อย");
          self.deletingCode = "";
          self.loadMembers(self.page);
        })
        .catch(function (err) {
          window.alert(err.message || "เกิดข้อผิดพลาดระหว่างลบข้อมูล");
          self.deletingCode = "";
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0"><i class="ri-team-line me-1 align-middle"></i>{{ pageTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการสมาชิกนักแต่ง</a></li>
              <li v-if="breadcrumbSection" class="breadcrumb-item">{{ breadcrumbSection }}</li>
              <li class="breadcrumb-item active">{{ breadcrumbActive }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="flash && flash.message" class="alert alert-dismissible fade show" :class="flash.kind === 'success' ? 'alert-success' : 'alert-danger'" role="alert">
      {{ flash.message }}
      <button type="button" class="btn-close" aria-label="ปิด" @click="flash = null"></button>
    </div>
    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{ error }}
      <button type="button" class="btn-close" aria-label="ปิด" @click="error = ''"></button>
    </div>

    <div class="row g-3 mb-3 row-cols-2 row-cols-xl-4">
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-light border rounded-3 member-stat-card"
          :class="{ 'is-active': writerType === '' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อแสดงทุกประเภท"
          :aria-pressed="writerType === '' ? 'true' : 'false'"
          @click="activateWriterFilter('')"
          @keydown="onStatKey($event, '')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-muted mb-1 small">ทั้งหมด</p>
                <h3 class="mb-0 fw-bold">{{ stats.total || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-4">
                  <i class="ri-team-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-primary-subtle border border-primary border-opacity-50 rounded-3 member-stat-card"
          :class="{ 'is-active': writerType === 'General Member' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรอง General Member"
          :aria-pressed="writerType === 'General Member' ? 'true' : 'false'"
          @click="activateWriterFilter('General Member')"
          @keydown="onStatKey($event, 'General Member')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-primary-emphasis mb-1 small">General</p>
                <h3 class="mb-0 fw-bold text-primary">{{ stats.general || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-primary-subtle text-primary rounded-circle fs-4">
                  <i class="ri-user-star-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-success-subtle border border-success border-opacity-50 rounded-3 member-stat-card"
          :class="{ 'is-active': writerType === 'Associate Member' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรอง Associate Member"
          :aria-pressed="writerType === 'Associate Member' ? 'true' : 'false'"
          @click="activateWriterFilter('Associate Member')"
          @keydown="onStatKey($event, 'Associate Member')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-success-emphasis mb-1 small">Associate</p>
                <h3 class="mb-0 fw-bold text-success">{{ stats.associate || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-success-subtle text-success rounded-circle fs-4">
                  <i class="ri-user-follow-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-warning-subtle border border-warning border-opacity-50 rounded-3 member-stat-card"
          :class="{ 'is-active': writerType === 'Provisional Member' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรอง Provisional Member"
          :aria-pressed="writerType === 'Provisional Member' ? 'true' : 'false'"
          @click="activateWriterFilter('Provisional Member')"
          @keydown="onStatKey($event, 'Provisional Member')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-warning-emphasis mb-1 small">Provisional</p>
                <h3 class="mb-0 fw-bold text-warning">{{ stats.provisional || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-warning-subtle text-warning rounded-circle fs-4">
                  <i class="ri-user-received-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="filter-search-by">ค้นหาด้วย</label>
            <select id="filter-search-by" v-model="searchBy" class="form-select" aria-label="เลือกประเภทการค้นหา" @change="onFilterChange">
              <option value="first_name">ชื่อสมาชิก / องค์กร / นามปากกา</option>
              <option value="member_code">รหัสสมาชิก</option>
              <option value="internal_no">Internal No.</option>
              <option value="ipi_name_no">IPI Name No.</option>
              <option value="ipi_base_no">IPI Base No.</option>
              <option value="pen_name">นามปากกา</option>
              <option value="email">อีเมล</option>
              <option value="mobile">มือถือ</option>
            </select>
          </div>
          <div class="col-xl-5 col-md-6">
            <label class="form-label" for="filter-search-keyword">คำค้นหา</label>
            <div class="input-group">
              <span class="input-group-text"><i class="ri-search-line"></i></span>
              <input
                id="filter-search-keyword"
                v-model="searchKeyword"
                type="text"
                class="form-control"
                :placeholder="searchPlaceholder"
                :title="searchTitle"
                @input="debounceLoad"
              >
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <label class="form-label" for="filter-sort">เรียงตาม</label>
            <select id="filter-sort" v-model="sort" class="form-select" aria-label="เรียงรายการสมาชิก" @change="onFilterChange">
              <option value="name">ชื่อ (ก–ฮ)</option>
              <option value="member_code_asc">รหัสสมาชิก (A–Z)</option>
              <option value="member_code_desc">รหัสสมาชิก (Z–A)</option>
              <option value="created_desc">วันที่เป็นสมาชิก (ใหม่สุด)</option>
              <option value="created_asc">วันที่เป็นสมาชิก (เก่าสุด)</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="filter-writer-type">ประเภทนักแต่ง</label>
            <select id="filter-writer-type" v-model="writerType" class="form-select" aria-label="กรองประเภทนักแต่ง" @change="onFilterChange">
              <option value="">ทั้งหมด</option>
              <option value="General Member">General Member</option>
              <option value="Associate Member">Associate Member</option>
              <option value="Provisional Member">Provisional Member</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="filter-rightsholder-type">ประเภทผู้ทรงสิทธิ</label>
            <select id="filter-rightsholder-type" v-model="rightsholderType" class="form-select" aria-label="กรองประเภทผู้ทรงสิทธิ" @change="onFilterChange">
              <option value="">ทั้งหมด</option>
              <option value="นักแต่งเพลง">นักแต่งเพลง</option>
              <option value="บริษัทผู้พิมพ์ผู้โฆษณา(Publisher)">บริษัทผู้พิมพ์ผู้โฆษณา(Publisher)</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="filter-status">สถานะสมาชิก</label>
            <select id="filter-status" v-model="status" class="form-select" aria-label="กรองสถานะสมาชิก" @change="onFilterChange">
              <option value="active">ใช้งาน</option>
              <option value="inactive">ไม่ใช้งาน</option>
              <option value="suspended">ระงับ</option>
              <option value="resigned">ลาออก</option>
              <option value="deceased">เสียชีวิต</option>
              <option value="">ทั้งหมด</option>
            </select>
          </div>
          <div class="col-xl-3 col-md-6">
            <label class="form-label" for="filter-created-source">นำเข้าข้อมูล</label>
            <select id="filter-created-source" v-model="createdSource" class="form-select" aria-label="กรองนำเข้าข้อมูล" @change="onFilterChange">
              <option value="">ทั้งหมด</option>
              <option value="online_application">ใบสมัครออนไลน์</option>
              <option value="manual_add">เพิ่มสมาชิกออฟไลน์</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 class="card-title mb-0">Table - รายการสมาชิก</h4>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <span class="text-muted">{{ metaText }}</span>
          <a v-if="canAdd" class="btn btn-primary btn-sm" :href="memberAddHref">
            <i class="ri-user-add-line align-bottom me-1"></i>เพิ่มสมาชิก
          </a>
          <button type="button" class="btn btn-soft-success btn-sm" @click="exportCsv">
            <i class="ri-file-excel-2-line align-bottom me-1"></i>ส่งออก Excel (CSV)
          </button>
          <button type="button" class="btn btn-soft-secondary btn-sm" @click="clearFilters">
            <i class="ri-filter-off-line align-bottom me-1"></i>ล้างตัวกรอง
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card mt-3 mb-1">
          <table class="table align-middle table-nowrap table-striped table-xs mb-0 table-bordered table-responsive-sm table-responsive-md table-responsive-lg table-primary table-striped table-hover">
            <thead class="table-light">
              <tr>
                <th style="width: 5%;">รูป</th>
                <th class="member-sort" :class="{ 'text-primary': sort === 'member_code_asc' || sort === 'member_code_desc' }" title="คลิกเพื่อเรียงตามรหัสสมาชิก" @click="cycleSort('member_code')">
                  รหัสสมาชิก <i class="sort-icon" :class="sortIconCode"></i>
                </th>
                <th>Internal No.</th>
                <th>IPI Name No.</th>
                <th class="member-sort" :class="{ 'text-primary': sort === 'name' }" title="คลิกเพื่อเรียงตามชื่อ" @click="cycleSort('name')">
                  ชื่อสมาชิก / องค์กร <i class="sort-icon" :class="sortIconName"></i>
                </th>
                <th>ติดต่อ</th>
                <th>สถานะ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="8" class="text-muted">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="error">
                <td colspan="8" class="text-danger">โหลดข้อมูลไม่สำเร็จ</td>
              </tr>
              <tr v-else-if="displayRows.length === 0">
                <td colspan="8" class="text-muted">ไม่พบข้อมูลสมาชิก</td>
              </tr>
              <template v-else>
              <tr v-for="item in displayRows" :key="item.code" class="member-data-row" @click="openProfile(item.code)">
                <td>
                  <div class="avatar-xs">
                    <img v-if="item.avatarSrc" :src="item.avatarSrc" alt="profile" class="rounded-circle avatar-xs object-fit-cover">
                    <span v-else class="avatar-title rounded-circle bg-primary-subtle text-primary fw-semibold">{{ item.avatarLetter }}</span>
                  </div>
                </td>
                <td>{{ safeCell(item.row.member_code) }}</td>
                <td>{{ safeCell(item.row.internal_no) }}</td>
                <td>
                  <div v-if="item.ipiName || item.ipiBase" class="lh-sm">
                    <div>{{ item.ipiName || '-' }}</div>
                    <div v-if="item.ipiBase" class="small text-muted">{{ item.ipiBase }}</div>
                  </div>
                  <template v-else>-</template>
                </td>
                <td>
                  <div class="lh-sm">
                    <div>{{ item.name.main }}</div>
                    <div v-if="item.name.pen" class="small text-muted">นามปากกา: {{ item.name.pen }}</div>
                    <div v-if="item.name.loc" class="small text-muted lh-sm">{{ item.name.loc }}</div>
                    <div v-if="item.name.eng" class="small text-muted lh-sm">{{ item.name.eng }}</div>
                    <div v-if="item.name.badges.length" class="mt-1 d-flex flex-wrap gap-1">
                      <span v-for="badge in item.name.badges" :key="badge.text" :class="badge.cls">{{ badge.text }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-if="item.email || item.mobile" class="small lh-sm">
                    <div v-if="item.email" class="text-truncate" style="max-width:200px" :title="item.email">
                      <i class="ri-mail-line text-muted me-1 align-middle"></i>{{ item.email }}
                    </div>
                    <div v-if="item.mobile" :class="{ 'mt-1': item.email }">
                      <i class="ri-phone-line text-muted me-1 align-middle"></i>{{ item.mobile }}
                    </div>
                  </div>
                  <template v-else>-</template>
                </td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <i
                      v-if="createdSourceIconClass(item.row.created_source)"
                      :class="createdSourceIconClass(item.row.created_source)"
                      class="fs-16 flex-shrink-0"
                      :title="createdSourceLabel(item.row.created_source)"
                    ></i>
                    <span class="badge" :class="memberStatusBadgeClass(item.row.status)">{{ memberStatusLabel(item.row.status) }}</span>
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-1">
                    <button type="button" class="btn btn-sm btn-soft-info btn-icon" title="ดูโปรไฟล์" aria-label="ดูโปรไฟล์" @click.stop="openProfile(item.code)">
                      <i class="ri-eye-line fs-16"></i>
                    </button>
                    <button
                      v-if="canDelete"
                      type="button"
                      class="btn btn-sm btn-soft-danger btn-icon"
                      title="ลบสมาชิก"
                      aria-label="ลบสมาชิก"
                      :disabled="deletingCode === item.code"
                      @click.stop="deleteMember(item.row)"
                    >
                      <i class="ri-delete-bin-line fs-16"></i>
                    </button>
                  </div>
                </td>
              </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-3">
          <div class="d-flex flex-wrap align-items-center gap-3">
            <small class="text-muted">{{ pageInfoText }}</small>
            <div class="d-flex align-items-center gap-2">
              <label class="form-label text-muted small mb-0" for="member-per-page">แถวต่อหน้า (เริ่มต้น 10)</label>
              <select id="member-per-page" v-model.number="perPage" class="form-select form-select-sm" style="width: 4.75rem" aria-label="จำนวนแถวต่อหน้า" title="จำนวนแถวต่อหน้า เริ่มต้น 10 แถว" @change="onPerPageChange">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
          <div class="pagination-wrap hstack gap-2">
            <button type="button" class="btn btn-sm btn-light" :disabled="page <= 1" @click="loadMembers(page - 1)">ก่อนหน้า</button>
            <ul class="pagination listjs-pagination mb-0">
              <li v-for="n in pageNumbers" :key="n" class="page-item" :class="{ active: n === page }">
                <button type="button" class="page-link" @click="loadMembers(n)">{{ n }}</button>
              </li>
            </ul>
            <button type="button" class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="loadMembers(page + 1)">ถัดไป</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.member-stat-card {
  cursor: pointer;
}
.member-stat-card.is-active {
  outline: 2px solid rgba(33, 37, 41, 0.35);
  outline-offset: 1px;
}
.member-sort {
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
}
.member-sort:hover {
  color: var(--vz-primary);
}
tr.member-data-row {
  cursor: pointer;
}
</style>
